module.exports = __webpack_public_path__ + "img/log-in.a62455b6.svg";